import React, { useEffect, useState } from 'react';
import { useSpearPartsApi } from '../../../../store/api/hooks/spearPartsApiHook';
import { PAGE_SIZE } from '../../../../_common/constant';
import Pagination from '../../../../components/pagination';
import Search from '../../../../components/search';
import { AgGridReact } from 'ag-grid-react';
import { showDate } from '../../../../_common/functions';

interface genProps {
  partDetails: any;
}
const StockPickingHistory: React.FC<genProps> = ({ partDetails }) => {

  const spearPartsAPI = useSpearPartsApi();
  const [gridApi, setGridApi] = useState<any>(null);
  const [gridColumnApi, setGridColumnApi] = useState<any>(null);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [searchParam, setSearchParam] = useState<string>('');

  const [rowData, setRowData] = useState<any>(null)

  const onGridReady = (params: any) => {
    setGridApi(params.api);
    setGridColumnApi(params.columnApi);
  };
  const onRowClicked = (event: any) => {
    if (!event.event.target.closest('input[type="checkbox"]')) {
      event.node.setSelected(false); // Unselect row if it's clicked, not by checkbox
    }
  };
  const getSpearPartsList = () => {
    spearPartsAPI.stockPickingHistory({
      partsID: partDetails.partsID,
      pageSize: PAGE_SIZE,
      pageNumber: currentPage,
      searchParam: searchParam,
    }, (data: any) => {
      setTotalRecords(data.totalRecord);
      setRowData(data.stockPickList ? data.stockPickList : []);
    }, (error: any) => {
      setRowData([]);
    });
  };

  useEffect(() => {
    getSpearPartsList();
  }, [currentPage, searchParam]);

  const columnDefs = [
    { headerName: 'Pick No', field: 'pickNo', headerClass: 'bg-[#f0f0f0]', width: 130 },
    {
      headerName: 'Pick Date', field: 'pickingDate', headerClass: 'bg-[#f0f0f0]', width: 130,
      cellRenderer: (data: any) => data.value ? showDate(data.value) : '--'
    },
    { headerName: 'Picked By', field: 'pickedByName', headerClass: 'bg-[#f0f0f0]', width: 130 },
    { headerName: 'Work Order Number', field: 'refWorkorderID', headerClass: 'bg-[#f0f0f0]', width: 170 },
    {
      headerName: 'Number of Parts', field: 'pickQuantity', headerClass: 'bg-[#f0f0f0]', width: 150,
      cellRenderer: (data: any) => {
        const pickQuantity = data.data?.pickQuantity || '--';
        const unitName = data.data?.unitName || '';
        return `${pickQuantity} ${unitName}`;
      }
    },
    { headerName: 'Facility', field: 'facilityName', headerClass: 'bg-[#f0f0f0]', width: 170 },
    { headerName: 'Sub Facility', field: 'subFacilityName', headerClass: 'bg-[#f0f0f0]', width: 170 },


  ];

  return (

    <div>
      <h1 className='pl-5 mt-5'>Stock Picking History</h1>
      <div className='flex items-center justify-between pl-5 pr-3 border-b border-gray-200 h-[3.75rem]'>
        <Pagination
          perPage={PAGE_SIZE}
          totalRecords={totalRecords}
          onPageChange={setCurrentPage}
          currentPage={currentPage}
        />
        <Search onSearch={setSearchParam} />
      </div>
      <div>
        <div className='bg-[#FAFAFA]'>

          <div className="ag-theme-alpine h-1/2">
            <AgGridReact
              columnDefs={columnDefs} // Pass columnDefs
              rowData={rowData} // Pass rowData
              pagination={false}
              rowSelection="multiple"
              onGridReady={onGridReady}
              domLayout="autoHeight"
              onRowClicked={onRowClicked}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default StockPickingHistory;